const depCalls = {};

function $runUFUNC() {
  for (const k in this.$computeds) {
    this.$updateUFUNC(k, this.$computeds[k]);
  }
}
function $updateUFUNC(designId, ufunc) {
  if (!this.$ufuncWatchs) {
    this.$ufuncWatchs = {};
  }
  let oldWatch = this.$ufuncWatchs[designId];
  if (oldWatch) {
    //销毁老监听器
    oldWatch();
    delete this.$ufuncWatchs[designId];
  }
  let uw = $UFUNCWatch.call(this, ufunc, designId);
  this.$ufuncWatchs[designId] = uw;
}
function $registerUFUNC(designId, ufunc) {
  if (designId && ufunc) {
    let change = true;
    //如果该组件已经注册过公式，则判断公式设置是否存在变化
    if (this.$computeds[designId]) {
      const old_ufunc = this.$computeds[designId];
      change = hasChange(old_ufunc, ufunc);
    }
    if (change) {
      ufunc = Vue.reactive(ufunc);
      this.$computeds[designId] = ufunc;
      if (this.$isDataLoaded) {
        this.$updateUFUNC(designId, ufunc);
      }
    }
  }
}
function $unRegisteUFUNC(designId, ufunc) {
  const uw = this.$ufuncWatchs?.[designId];
  if (uw && dsf.isFunction(uw)) {
    uw();
    delete this.$ufuncWatchs[designId];
    delete this.$computeds[designId];
    delete depCalls[designId];
  }
}

function hasChange(ov, v) {
  if (ov && v) {
    if (ov.expression !== v.expression || ov.immediate !== v.immediate) {
      return true;
    }
    return false;
  } else {
    return true;
  }
}

//计算公式监听
function $UFUNCWatch(ufunc, designId) {
  let _this = this;
  if (dsf.isUnDef(_this.depCalls)) {
    _this.depCalls = {};
  }
  //判断第一次监听调用，第一次监听调用是个vue依赖收集过程，如果immediate为false时候不会触发变化处理函数
  if (dsf.isUnDef(depCalls[designId])) {
    depCalls[designId] = true;
  }
  let watchFn = function () {
    let result = null;
    if (this.$isDataLoaded) {
      const uf = dsf.isFunction(ufunc) ? ufunc() : ufunc;
      const { computed, local } = uf;
      // let local = self.local;、
      result = computed.call(this, _this, local);
      let valStr = result + "";
      // 使用正则表达式检查特殊字符串
      let isSpecial = valStr.match(/NaN|Infinity|undefined|null/);
      if (isSpecial) {
        result = null;
      }
    }
    if (!ufunc.immediate && depCalls[designId]) {
      result = "__depCall__";
    }
    if (depCalls[designId]) {
      depCalls[designId] = false;
    }
    return result;
  };
  let watchHandler = function (v) {
    if (v !== "__depCall__") {
      ufunc.model.callback.call(this, v);
    }
  };

  // let uw = this.$watch(watchFn, watchHandler, {
  //   // deep: true,
  //   immediate: ufunc.immediate
  // });
  let uw = Vue.watchEffect(() => {
    let result = watchFn.call(this);
    watchHandler.call(this, result);
  });
  return function () {
    uw();
    watchFn = null;
    watchHandler = null;
  };
}

export { $runUFUNC, $updateUFUNC, $registerUFUNC, $unRegisteUFUNC, $UFUNCWatch };
